import ErrorView from "@hpo/client/utilities/ErrorView";
import MessageException from "@hpo/client/utilities/errors/MessageException";

const FourOFour = () => {
  return <ErrorView error={new MessageException("Route inconnue", "404")} />;
};

export default FourOFour;
